module.exports = __webpack_public_path__ + "media/common/statics/finish_icon-93f2e86ed282008a7171d178a7caa67e.png";